/** Persister IndexedDB per react-query: i dati restano sul telefono anche offline. */
import { get, set, del } from "idb-keyval";

const KEY = "kilolava.rq.cache.v1";

export const idbPersister = {
  persistClient: async (client) => {
    try { await set(KEY, client); } catch { /* quota */ }
  },
  restoreClient: async () => {
    try { return await get(KEY); } catch { return undefined; }
  },
  removeClient: async () => {
    try { await del(KEY); } catch { /* ignore */ }
  },
};
